var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container is-fluid"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('common.workflow'))+" "+_vm._s(_vm.workflow.name))]),_c('workflow-chart',{attrs:{"id":_vm.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }